module.exports = __webpack_public_path__ + "static/media/edit.24a7029b.svg";